import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Icon, Toast } from "antd-mobile";
import BridgeV2 from "@akulaku/web-bridge";
import _ from "lodash";
import { customSentryReportIfEnabled, withT } from "@al/next/al-ex";
import { WebpImage } from "@al/akui-mobile";
import classNames from "classnames";

import Loading from "~/components/ui/Loading";

import SharePanelComponent from "./SharePanel";
import { ChannelType } from "./types";
import _share from "./_share";

const __get__supported__channel = () =>
  new Promise((resolve, reject) => {
    if (BridgeV2["getShareChannelsV2"]) {
      BridgeV2.getShareChannelsV2("", function (res) {
        // 兼容处理，Android 返回为 data.datas
        // iOS 返回为 data.data
        const supportedChannelIdList = _.get(res, "data.datas") || _.get(res, "data.data");
        if (_.isArray(supportedChannelIdList) && supportedChannelIdList.length > 0) {
          // Instagrame 已经去掉，但是原生未去除
          resolve(supportedChannelIdList.filter((item) => item !== ChannelType.Instagram));
        }
      });
    }
  });

const ShareStatus = {
  0: "success",
  1: "cancel",
  2: "fail",
};

export default class Share extends Component {
  static propTypes = {
    /**
     * 开发阶段外部浏览器的开发
     */
    __test: PropTypes.bool,
    /**
     * 分享渠道
     */
    channelIds: PropTypes.array,
    /**
     * 分享弹窗是否可见
     */
    visible: PropTypes.bool,
    /**
     * 点击分享渠道回调
     */
    onShare: PropTypes.func,
    /**
     * shareinfo单独请求获取
     */
    getShareInfo: PropTypes.func,
    /**
     * 与getShareInfo的区别,暂时兼容
     */
    shareInfo: PropTypes.shape({
      shareContentUrl: PropTypes.string,
      shareContentTitle: PropTypes.string,
      shareContentDescription: PropTypes.string,
      shareImageUrl: PropTypes.string,
      callback: PropTypes.func,
      // 神策埋点需要的字段
      sharePageId: PropTypes.string,
      sharePageName: PropTypes.string,
    }),
    className: PropTypes.string,
    children: PropTypes.any,
    /**
     * 分享弹窗标题
     */
    title: PropTypes.string,
    /**
     * 是否显示分享弹窗二维码
     */
    enableQrCode: PropTypes.bool,
    /**
     * 顶部内容
     */
    topContent: PropTypes.any,
    /**
     * 分享后的回调
     * {
     * status:success|cancle|fail
     * }
     */
    afterShare: PropTypes.func,
    /**
     * 点击 x 或 mask 回调
     */
    onClose: PropTypes.func,
    isSign: PropTypes.bool,
    /**
     * 副标题
     */
    subTitle: PropTypes.string,
  };

  static defaultProps = {};

  state = {
    supportedChannelIdList: this.props.__test ? [2, 3, 5, 6, 10] : [5],
    visible: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.visible !== state.visible) {
      return {
        visible: props.visible,
      };
    } else {
      return null;
    }
  }

  componentDidMount() {
    this.getSupportedChannelIdList();
  }

  // UNSAFE_componentWillReceiveProps({ visible }) {
  //   const { __test } = this.props;

  //   if (!__test && visible && this.__unsupported__channels) {
  //     visible = false;
  //     setTimeout(() => {
  //       this.share();
  //       this.props.onClose && this.props.onClose();
  //       // run(this.props, "onClose");
  //     });
  //   }

  //   this.setState({
  //     visible,
  //   });
  // }

  __unsupported__channels = false;

  getSupportedChannelIdList = async () => {
    // try {
    const supportedChannelIdList = await __get__supported__channel();
    this.setState({
      supportedChannelIdList,
    });
    // } catch (err) {
    //   customSentryReportIfEnabled("getSupportedChannelIdList error", "basic component");
    //   this.__unsupported__channels = true;
    // }
  };

  close = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  share = async (channelId = -1, index) => {
    const { shareInfo, getShareInfo, afterShare, onShare } = this.props;
    if (getShareInfo || shareInfo) {
      this.setState({
        loading: true,
      });
      try {
        // 可能存在异步获取分享信息
        const curShareInfo = (await getShareInfo(channelId)) || shareInfo;
        onShare && onShare(curShareInfo, channelId, index);
        const _callback = curShareInfo.callback;
        curShareInfo.callback = (res) => {
          _callback && _callback(res);
          afterShare && afterShare(res);
        };
        // 如果开启了二维码分享就可以获取到离屏渲染的 canvas
        if (channelId === ChannelType.Whatsapp) {
          const canvasEl = document.querySelector(".off_screen_canvas");
          canvasEl?.dataset?.remoteUrl && Object.assign(curShareInfo, { shareImageUrl: canvasEl.dataset.remoteUrl });
        }
        await _share(curShareInfo, channelId);
      } catch (error) {
        customSentryReportIfEnabled(error, "basic component");
      } finally {
        this.setState({
          loading: false,
        });
      }
    } else {
      customSentryReportIfEnabled("share 缺少分享信息", "basic component");
    }
  };

  render() {
    return (
      <SharePanelComponent
        visible={this.state.visible}
        onClose={this.close}
        share={this.share}
        title={this.props.title}
        enableQrCode={this.props.enableQrCode}
        topContent={this.props.topContent}
        subTitle={this.props.subTitle}
        loading={this.state.loading}
        getShareInfo={this.props.getShareInfo}
        supportedChannelIdList={this.state.supportedChannelIdList}
        channelIds={this.props.channelIds}
      />
    );
  }
}
